<template>
  <el-form class="create-jobs-work">
    <el-dialog append-to-body title="Отчет по работе" :visible.sync="open">
      <el-input placeholder="Название" style="margin-bottom: 8px" v-model="form.name"></el-input>
      <div style="display: flex">
        <el-input placeholder="План" v-model="form.plan" style="margin-bottom: 8px"></el-input>
        <unit-select hide-label style="margin-bottom: 8px; max-width: 120px; margin-left: 4px" v-model="form.unit"
                     placeholder="Eд. изм."/>
      </div>
      <el-input v-model="form.comment" placeholder="Комментарий" type="textarea" textarea/>
      <filter-select label="Вид работ" style="margin-bottom: 0" :options="work_type_options" v-model="form.work_type"/>
      <el-form-item
        style="margin-bottom: 0px" v-if="$store.getters.permission.price && this.$store.state.project.workorder.price"
                    :label="`${$store.getters.permission.price && $store.getters.permission.unit_name || 'Стоимость'} на ед. объема`">
        <el-input v-model="form.price_unit" placeholder=""/>
      </el-form-item>
      <el-form-item style="margin-bottom: 0px" v-if="$store.getters.permission.price && this.$store.state.project.workorder.price" label="Стоимость итого">
        <el-input v-model="form.total_price" placeholder=""/>
      </el-form-item>

      <div class="tech-prof-container">
        <div class="tech-prof" v-if="this.$store.state.project.workorder.prof">
          <div style="display: flex">
            <strong style="margin-right: 8px">Численность</strong>
            <add-prof-tech :table="form.PROF" type="PROF" @save="saveProf"/>
          </div>
          <el-input v-model="form.PROF.total || 0" placeholder=""/>
        </div>
        <div class="tech-prof" v-if="this.$store.state.project.workorder.tech">
          <div style="display: flex">
            <strong style="margin-right: 8px">Техника</strong>
            <add-prof-tech :table="form.TECH" type="TECH" @save="saveTech"/>
          </div>
          <el-input v-model="form.TECH.total || 0" placeholder=""/>
        </div>
      </div>

      <div class="object-select">
        <strong style="color: #000; margin-top: 8px">Работа из плана</strong>
      </div>
      <div class="jobs-plan" @click="openSelectJob = true">
        <div v-if="form.job && form.job.name && form.originalId">
          {{ form.job.name }}
        </div>
        <div v-else></div>
        <div>
          <i class="fa fa-edit"></i>
        </div>
      </div>
      <el-dialog append-to-body title="Выбрать работу" :visible.sync="openSelectJob">
        <permission-jobs-work-object @select-job="selectJob" :select-only="true"/>
      </el-dialog>
      <div class="object-select" v-if="object && object.name">
        <div>{{ object.name }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="open = false">Закрыть</el-button>
        <el-button type="primary" @click="save">Сохранить</el-button>
      </span>
    </el-dialog>
  </el-form>
</template>

<script>

// $store.state.project.available_reports
import FilterSelect from "../../../../components/FilterSelect";
import PermissionJobsWorkObject from "./PermissionJobsWorkObject";
import firebase from "firebase";
import UnitSelect from "../../components/unitSelect";
import _ from "lodash";
import {filterObjects} from "../../../../utils/filterJobs";
import {getChildList} from "../../../../utils/getChild";
import {getPermission, getPermissionByUser} from "../../../../firestore/permission";
import AddProfTech from "./AddProfTech";

export default {
  name: "CreateJobsReport",
  components: {AddProfTech, UnitSelect, PermissionJobsWorkObject, FilterSelect},
  data() {
    return {
      open: false,
      permission: {},
      structureObj: null,
      form: {
        work_type: '',
        comment: '',
        job: null,
        name: '',
        price_unit: '',
        unit: null,
        total_price: '',
        TECH: {},
        PROF: {},
        originalId: null
      },
      object: null,
      list: [],
      work_type_options: [],
      isEdit: false,
      openSelectJob: false
    }
  },
  async mounted() {
    this.permission = await getPermission(this.$store.state.project.id, this.$store.state.company.uid || firebase.auth().currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id), undefined, true);
    if (!this.$store.state.project.version && !this.permission.usePermission) {
      this.permissionUser = await getPermissionByUser(this.$store.state.project.id, firebase.auth().currentUser.uid, this.$store.state.project.plan && this.$store.state.project.plan.id);
    }
    this.fetchTree()
    this.getWorkType('job')

  },
  methods: {
    save() {
      this.$emit('save',  {form: this.form, structureObj:  this.structureObj, isEdit: this.isEdit})
      this.open = false;
    },
    openHandler(object, job) {
      this.isEdit = false
      this.form = {
        work_type: '',
        comment: '',
        job: null,
        name: '',
        price_unit: '',
        unit: null,
        total_price: '',
        TECH: {},
        PROF: {},
        originalId: null
      }
      this.open = true
      this.structureObj = object

      if (job) {
        this.form = {
          ... this.form,
          ...job
        }
        this.isEdit = true
      }
    },
    saveProf(p) {
      this.form.PROF = {...p}
    },
    saveTech(p) {
      this.form.TECH = {...p}
    },
    selectJob(e) {
      this.form.job = {
        ...e._data,
      }
      this.form = {
        ...this.form,
        originalId: e.id
      }
      this.openSelectJob = null
      if (e._data.objects && e._data.objects.length) {
        this.object = this.list.find((l) => l.id === e._data.objects[0])
      }
    },
    fire() {
      if (this.$route.query.version) {
        return firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('versions')
          .doc(this.$route.query.version)
      }

      if (this.$route.query.plan || (this.$store.state.project.plan && this.$store.state.project.plan.id)) {
        return firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.$route.query.plan || (this.$store.state.project.plan && this.$store.state.project.plan.id))
      }

      return firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    fetchTree() {
      this.loader = true;
      const result = [];
      this.fire()
        .collection('objects')
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              objects: data.objects,
              index: data.index,
              parentId: data.parentId || undefined,
              isParent: data.isParent,
            });
          });
        }).finally(() => {
        this.list = _.orderBy(filterObjects(filterObjects(getChildList(result), this.permission), this.permissionUser), 'index', ['asc']);

        this.loader = false;
      }).catch(() => {
        this.loader = false;
      });
    },
    getWorkType(type) {
      console.log('GET_WORK_TYEP f')

      return new Promise((resolve, reject) => {
        const result = [];
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('works_type')
          .where('type', '==', type).get().then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              data: data,
              value: subDoc.id,
              label: (data.name || data.id || '') + (data.stamp ? ' ' + data.stamp : ''),
            });
          });
          this.work_type_options = result;
        });
      });
    },
  }
}
</script>

<style scoped lang="scss">
.create-jobs-work {

}

.tech-prof-container {
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;

  .tech-prof {
    display: flex;
    color: #000000 !important;
    flex: 1;
    flex-direction: column;
    align-items: flex-start;

    strong {
      color: #000 !important;
    }
  }
}

.jobs-plan {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  height: 40px;
  padding: 0 15px;
  align-items: center;
  box-sizing: border-box;
  margin-top: 8px;
  color: #000;
}

.object-select {
  display: flex;
  flex: 1;
  justify-content: flex-start;
}
</style>
<style lang="scss">

.create-jobs-work {
  .el-form-item {
    margin-bottom: 8px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/ReportsOneComplete/components/CreateJobsReport.vue